import * as React from 'react';

import Progress from "../../../common/organism/progress";

import ClientContractMainCreateForm from "./create/client_contract_main_create_form";
import {Project} from "../../../../domain/model/project";
import {Customer} from "../../../../domain/model/customer";
import {Contract} from "../../../../domain/model/contract";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import EmptyData from "../../../common/organism/empty_data";
import ProjectThumbnail from "./share/project_thumbnail";
import {ContractCreate} from "../../../../config/view_const/contract";
import {TBreadcrumbItem} from "../../../type/common";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";


interface IProps {
    isInit: boolean;
    isLoading: boolean;
    project: Project | null;
    customer: Customer | null;
    contract: Contract | null;
    handleCreateSubmit: (values: any) => void
}

const ClientContractCreateComponent: React.FC<IProps> = (props) => {
    const {isLoading,
        project,
        customer, contract, handleCreateSubmit} = props;

    const initialValues = {
        contract,
        customer,
    };

    if(!project) {
        return <div/>
    }

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        {text: `[成約報告]${project.name}`}
    ]

    return (
        <React.Fragment>

            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />
                <ProjectThumbnail project={project}/>
                { contract && contract.companyID !== "create"
                    ? <EmptyData main={ContractCreate.CreatedMain} description={ContractCreate.CreatedDescription}/>
                    : <ClientContractMainCreateForm
                        initialValues={initialValues}
                        onSubmit={handleCreateSubmit}
                    />
                }

            </PageWrapper>

        </React.Fragment>
    )

};

export default ClientContractCreateComponent;




// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/client_contract_create.tsx